import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppTimeHeader from '../containers/AppTimeHeader'
import { withNamespaces } from "react-i18next"
import StepBarTime from '../components/StepBarTime'
import { CreditCard } from 'lucide-react'
import { postRedsys, fetchCustomer } from '../actions/qrstime'
import { postGpPayment } from '../actions/qrs'
import { currencySymbol } from '../utils/currency';

// Addon Payments (Comercia Global Payments): the HPP posts its result here;
// the endpoint validates it server-side and bounces back to the time ticket.
const GP_RESPONSE_URL = 'https://lockers-qr-api.vacway.es/v1/qrs/gp-response'

class PaymentTimeView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      redsysSignature: null,
      redsysMerchant: null,
      redsysVersion: null,
      minutes: 5,
      seconds: 0,
      isTimeUp: false,
      iva: 21,
      importeBase: null,
      importeIva: null,
      total: null,
      // Addon Payments (HPP) state
      gpJson: null,
      gpUrl: null,
      gpScriptLoaded: false,
      gpInitialized: false,
      gpError: null,
    }
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';

    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getPrimaryColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.primaryColor || '#01315f';
  }

  componentDidMount() {
    const {
      zoneSelected, descriptionZone, selectedLocker, lockerPrice,
      totalMinutes, slotMinutes, slotCount, pricePerSlot,
      lockerAssigned, lockerMatricula, lockerCustomer, lockerCustomerID,
      qr, qrType, qrMode, phoneNumber, timeConfig,
    } = this.props.location.state;

    // Guard: if this locker already has a completed rental ticket, the user must not
    // re-enter the purchase flow (e.g. via browser back). Send them to the QR home view.
    const existingTicket = (() => { try { return JSON.parse(sessionStorage.getItem('vacway_time_ticket')); } catch { return null; } })();
    if (existingTicket && existingTicket.lockerAssigned === lockerAssigned) {
      history.replace(`/qrsale/${qr}`);
      return;
    }

    const { t, i18n } = this.props;

    // Calculate IVA
    const iva = 21;
    const total = lockerPrice;
    const importeBase = (total / (1 + iva / 100)).toFixed(2);
    const importeIva = (total - importeBase).toFixed(2);

    this.setState({ total, importeBase: parseFloat(importeBase), importeIva: parseFloat(importeIva) });

    // Start countdown
    this.startCountdown();

    // Redsys language map
    let language = '001';
    switch (i18n.language) {
      case 'es': language = '001'; break;
      case 'en': language = '002'; break;
      case 'it': language = '007'; break;
      case 'de': language = '005'; break;
      case 'fr': language = '004'; break;
      case 'pt': language = '009'; break;
      default: language = '002'; break;
    }

    const paymentProvider = this.props.qrData?.PaymentProvider || 'redsys';
    const useInsite = this.props.qrData?.useRedsysInsite || false;
    this._isAddon = paymentProvider === 'addon';

    // Addon Payments requires a globally unique ORDER_ID per attempt
    const paymentId = this._isAddon
      ? `GP${Date.now()}${Math.floor(Math.random() * 900 + 100)}`
      : Math.floor(Math.random() * 1000000 + 1).toString();
    const paymentDate = new Date().toISOString();

    const redsysURLOK = `https://lockers-qr.vacway.es/ticketTimeView?zoneSelected=${zoneSelected}&descriptionZone=${descriptionZone}&selectedLocker=${selectedLocker}&lockerPrice=${lockerPrice}&lockerAssigned=${lockerAssigned}&lockerMatricula=${lockerMatricula}&lockerCustomer=${lockerCustomer}&qrToken=${qr}&qrType=${qrType}&qrMode=${qrMode}&phoneNumber=${phoneNumber}&totalMinutes=${totalMinutes}&slotMinutes=${slotMinutes}&slotCount=${slotCount}&pricePerSlot=${pricePerSlot}&language=${i18n.language}&paymentId=${paymentId}&paymentDate=${encodeURIComponent(paymentDate)}&courtesyTime=${timeConfig?.courtesyTime || 5}&lockerCustomerID=${lockerCustomerID}`;
    const redsysURLKO = `https://lockers-qr.vacway.es/paymentTimeError?qr=${qr}&language=${i18n.language}`;

    if (this._isAddon) {
      // ── Addon Payments (HPP) ─────────────────────────────────────────────
      // Credentials are resolved server-side (Customer.AddonPayments); the
      // browser only sends amount + identifiers and gets the signed JSON back.
      if (useInsite) this.loadGpScript();

      this.props.postGpPayment({
        customerId: lockerCustomerID,
        price: lockerPrice,
        paymentId,
        urlOk: redsysURLOK,
        urlKo: redsysURLKO,
        isTest: qrType === 'test',
        // HPP_LANG takes ISO codes; the app's own code for German is 'gr'
        language: i18n.language === 'gr' ? 'de' : i18n.language,
        customerPhone: phoneNumber ? `+${phoneNumber}` : undefined,
      })
        .then((answer) => {
          const gp = answer && answer.response;
          if (!gp || gp.error || !gp.hppJson) {
            console.error('[GP] payment init failed:', gp);
            this.setState({ gpError: (gp && gp.error) || 'No se pudo iniciar el pago' });
            return;
          }
          this.setState({ gpJson: gp.hppJson, gpUrl: gp.hppUrl });
        })
        .catch((error) => {
          console.error('[GP] payment init error:', error);
          this.setState({ gpError: 'No se pudo iniciar el pago' });
        });
      return;
    }

    let redsysPetition = {
      price: lockerPrice,
      redsysURLOK,
      redsysURLKO,
      paymentId,
      merchantCode: '351639505',
      currency: '978',
      terminal: '1',
      merchantUrl: 'https://vacway.com',
      secretKey: 'xhI+J4wrx0JKkeGqJ12j2+ErLNH9OpHM',
      language,
    };

    this.props.fetchCustomer(lockerCustomerID)
      .then((customer) => {
        if (customer.response?.Redsys) {
          redsysPetition.merchantCode = customer.response.Redsys.MERCHANTCODE;
          redsysPetition.currency = customer.response.Redsys.CURRENCY;
          redsysPetition.terminal = customer.response.Redsys.TERMINAL;
          redsysPetition.merchantUrl = customer.response.Redsys.MERCHANTURL;
          redsysPetition.secretKey = customer.response.Redsys.SECRETKEY;
        }

        this.props.postRedsys(redsysPetition)
          .then((answer) => {
            const answerRedsys = answer.response;
            this.setState({
              redsysSignature: answerRedsys.Ds_Signature,
              redsysMerchant: answerRedsys.Ds_MerchantParameters,
              redsysVersion: answerRedsys.Ds_SignatureVersion,
            });
          })
          .catch(console.error);
      })
      .catch(console.error);
  }

  componentDidUpdate() {
    if (!this._isAddon) return;
    const useInsite = this.props.qrData?.useRedsysInsite || false;
    const { gpScriptLoaded, gpJson, gpUrl } = this.state;
    if (useInsite && !this._gpInitStarted && gpScriptLoaded && gpJson && gpUrl) {
      this._gpInitStarted = true;
      this.initGpEmbedded();
    }
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval);
    const gpScript = document.getElementById('gp-hpp-script');
    if (gpScript) gpScript.remove();
  }

  // ─── Addon Payments (HPP) ──────────────────────────────────────────────────

  loadGpScript() {
    if (document.getElementById('gp-hpp-script') || window.RealexHpp) {
      this.setState({ gpScriptLoaded: true });
      return;
    }
    const script = document.createElement('script');
    script.id = 'gp-hpp-script';
    script.src = '/lib/rxp-js.js';
    script.onload = () => this.setState({ gpScriptLoaded: true });
    script.onerror = () => this.setState({ gpError: 'Error al cargar el formulario de pago' });
    document.head.appendChild(script);
  }

  initGpEmbedded() {
    const { gpJson, gpUrl } = this.state;
    if (!document.getElementById('gp-pay-button') || !document.getElementById('gp-hpp-frame') || !window.RealexHpp) {
      this.setState({ gpError: 'Error al inicializar el formulario de pago' });
      return;
    }
    try {
      window.RealexHpp.setHppUrl(gpUrl);
      // Embedded mode: the HPP renders inside our iframe (3DS2 included) and,
      // when the payment finishes, rxp-js POSTs the result to GP_RESPONSE_URL
      // at top level. This view has no navigation guards to release.
      window.RealexHpp.embedded.init('gp-pay-button', 'gp-hpp-frame', GP_RESPONSE_URL, gpJson);
      this.setState({ gpInitialized: true });
      // Open the HPP form right away: the hidden trigger button is only
      // rxp-js's attach point.
      setTimeout(() => {
        const btn = document.getElementById('gp-pay-button');
        if (btn) btn.click();
      }, 0);
    } catch (err) {
      console.error('[GP] embedded init error:', err);
      this.setState({ gpError: 'Error al inicializar el formulario de pago' });
    }
  }

  gpPaymentForm(buttonStyle) {
    const { gpJson, gpUrl, gpInitialized, gpError, total } = this.state;
    const { qrType } = this.props.location.state;
    const { t } = this.props;
    const useInsite = this.props.qrData?.useRedsysInsite || false;

    if (gpError) {
      return (
        <div className="time-loading-payment">
          <p style={{ color: '#e74c3c' }}>{gpError}</p>
        </div>
      );
    }

    if (!gpJson || !gpUrl) {
      return (
        <div className="time-loading-payment">
          <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
          <p>{t('Preparando pasarela de pago...')}</p>
        </div>
      );
    }

    if (useInsite) {
      // In-site mode: the HPP form opens automatically inside this iframe
      return (
        <div className="time-redsys-form">
          {!gpInitialized && (
            <div className="time-loading-payment">
              <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
            </div>
          )}
          <button type="button" id="gp-pay-button" style={{ display: 'none' }} />
          <iframe
            id="gp-hpp-frame"
            title="Pago seguro"
            style={{
              display: 'none',
              width: '100%',
              height: '640px',
              border: '1px solid rgba(10,29,61,0.15)',
              borderRadius: '12px',
              marginTop: '12px',
              background: '#ffffff',
            }}
          />
        </div>
      );
    }

    // Redirect mode: classic signed form POST to the HPP (Cyberpac-style)
    return (
      <form action={gpUrl} method="POST" acceptCharset="UTF-8" className="time-redsys-form" name="peticionGp">
        {Object.entries(gpJson).map(([key, value]) => (
          <input type="hidden" name={key} value={String(value)} key={key} />
        ))}
        <button type="submit" className="time-pay-btn" style={buttonStyle}>
          <span className="time-pay-icon">💳</span>
          {qrType === 'test' ? t('TEST') : t('PAGAR')} {total ? total.toFixed(2) : '--'} {currencySymbol()}
        </button>
      </form>
    );
  }

  startCountdown = () => {
    this.countdownInterval = setInterval(() => {
      if (this.state.seconds > 0) {
        this.setState(prev => ({ seconds: prev.seconds - 1 }));
      } else {
        if (this.state.minutes > 0) {
          this.setState(prev => ({ minutes: prev.minutes - 1, seconds: 59 }));
        } else {
          clearInterval(this.countdownInterval);
          this.setState({ isTimeUp: true });
        }
      }
    }, 1000);
  }

  render() {
    const { t } = this.props;
    const { redsysSignature, redsysMerchant, redsysVersion, minutes, seconds, isTimeUp, total, importeBase, importeIva, iva } = this.state;
    const primaryColor = this.getPrimaryColor();
    const buttonStyle = this.getButtonStyle();

    const {
      selectedLocker, totalMinutes, lockerMatricula, lockerPrice, timeConfig
    } = this.props.location.state;

    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    const timeDisplay = hours > 0 ? (mins > 0 ? `${hours}h ${mins}min` : `${hours}h`) : `${mins}min`;

    if (isTimeUp) {
      return (
        <div className="timeBackground">
          <AppTimeHeader />
          <div className="time-page-wrap">
            <div className="time-content time-center">
              <img src="/images/timeout.svg" alt="Timeout" className="time-timeout-img" />
              <h3>{t('Tiempo agotado')}</h3>
              <p>{t('El tiempo para completar el pago ha expirado. Por favor, vuelve a intentarlo.')}</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-locker-selector-wide">
            <div className="time-page-header">
              <div className="time-page-header-icon" style={buttonStyle}>
                <CreditCard size={24} strokeWidth={2} />
              </div>
              <div className="time-page-header-text">
                <h2>{t('Resumen y Pago')}</h2>
                <p>{t('Revisa tu reserva y completa el pago de forma segura')}</p>
              </div>
              <span className="time-page-header-step">4 / 5</span>
            </div>

            <div className="time-payment-timer" style={{ borderColor: primaryColor }}>
              <span>{t('Tiempo para pagar')}</span>
              <strong style={{ color: minutes < 1 ? '#e74c3c' : primaryColor }}>
                {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
              </strong>
            </div>

            <div className="time-summary-card" style={{ borderColor: primaryColor }}>
              <div className="time-summary-row">
                <span>{t('Taquilla')}</span>
                <strong>{selectedLocker}</strong>
              </div>
              <div className="time-summary-row">
                <span>{t('Matrícula')}</span>
                <strong>{lockerMatricula}</strong>
              </div>
              <div className="time-summary-row">
                <span>{t('Tiempo alquilado')}</span>
                <strong>{timeDisplay}</strong>
              </div>
              <div className="time-summary-row">
                <span>{t('Cortesía')}</span>
                <strong>+{timeConfig?.courtesyTime || 5} min</strong>
              </div>
              <div className="time-summary-divider"></div>
              <div className="time-summary-row">
                <span>{t('Base imponible')}</span>
                <strong>{importeBase ? importeBase.toFixed(2) : '--'} {currencySymbol()}</strong>
              </div>
              <div className="time-summary-row">
                <span>{t('IVA')} ({iva}%)</span>
                <strong>{importeIva ? importeIva.toFixed(2) : '--'} {currencySymbol()}</strong>
              </div>
              <div className="time-summary-divider"></div>
              <div className="time-summary-row time-summary-total">
                <span>{t('TOTAL')}</span>
                <strong>{total ? total.toFixed(2) : '--'} {currencySymbol()}</strong>
              </div>
            </div>

            {this._isAddon ? (
              this.gpPaymentForm(buttonStyle)
            ) : redsysSignature && redsysMerchant && redsysVersion ? (
              <form
                action="https://sis.redsys.es/sis/realizarPago"
                method="POST"
                className="time-redsys-form"
              >
                <input type="hidden" name="Ds_SignatureVersion" value={redsysVersion} />
                <input type="hidden" name="Ds_MerchantParameters" value={redsysMerchant} />
                <input type="hidden" name="Ds_Signature" value={redsysSignature} />

                <button type="submit" className="time-pay-btn" style={buttonStyle}>
                  <span className="time-pay-icon">💳</span>
                  {t('PAGAR')} {total ? total.toFixed(2) : '--'} {currencySymbol()}
                </button>
              </form>
            ) : (
              <div className="time-loading-payment">
                <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
                <p>{t('Preparando pasarela de pago...')}</p>
              </div>
            )}

          </div>
        </div>
        <StepBarTime step={4} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postRedsys: bindActionCreators(postRedsys, dispatch),
  postGpPayment: bindActionCreators(postGpPayment, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PaymentTimeView));
